import { render, staticRenderFns } from "./snailVideoList.vue?vue&type=template&id=4d1d0da6&scoped=true&"
import script from "./snailVideoList.vue?vue&type=script&lang=js&"
export * from "./snailVideoList.vue?vue&type=script&lang=js&"
import style0 from "./snailVideoList.vue?vue&type=style&index=0&id=4d1d0da6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d0da6",
  null
  
)

export default component.exports